function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 2.5a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0zm0 9a2.5 2.5 0 105.002-.002A2.5 2.5 0 000 11.5zm0 9a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z",
  fillRule: "evenodd"
});

function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 23
  }, props), _ref);
}

export default SvgMore;